
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { WorldCountry } from '@/data/countries/types';
import { useLanguage } from '@/context/LanguageContext';

interface CountryHeroSectionProps {
  country: WorldCountry;
}

const CountryHeroSection = ({ country }: CountryHeroSectionProps) => {
  const { t } = useLanguage();

  return (
    <div className="bg-brand-blue-50 py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-brand-gray-900 mb-4 text-center">
            Best Therapists, Psychologists & Psychotherapists in {country.name}
          </h1>
          <p className="text-lg text-brand-gray-700 text-center mb-8 max-w-3xl mx-auto">
            Discover the best therapists, psychologists, and psychotherapists in {country.name} through our comprehensive directory 
            of certified mental health professionals. Connect with qualified therapists, experienced psychologists, and licensed psychotherapists who understand 
            the unique needs of {country.name} residents and provide culturally sensitive care.
          </p>
          
          <nav aria-label="Breadcrumb" className="mb-8">
            <ol className="flex justify-center text-sm">
              <li className="flex items-center">
                <Link to="/" className="text-brand-blue-600 hover:text-brand-blue-800">Home</Link>
                <span className="mx-2">/</span>
              </li>
              <li className="flex items-center">
                <Link to="/directory" className="text-brand-blue-600 hover:text-brand-blue-800">Directory</Link>
                <span className="mx-2">/</span>
              </li>
              <li className="text-brand-gray-600">Best Therapists, Psychologists & Psychotherapists in {country.name}</li>
            </ol>
          </nav>
          
          <div className="flex justify-center mb-8">
            <Button variant="outline" asChild>
              <Link to="/directory" aria-label="Back to all countries directory">
                <ArrowLeft className="mr-2 h-4 w-4" />
                {t('backToAllCountries')}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryHeroSection;
